import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";
import './pop.css';
import close from '../../assets/close.svg'
// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   bgcolor: "background.paper",
//   borderRadius: "18px",
//   outline:"none"
// };

export default function PopupModal({ handleClose, open, content, width,disableHead=true,card_width }) {
  return (
    <Modal
      open={open}
      onClose={(e, reason) => {
        if (reason && reason === "backdropClick") return;
        handleClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box width={"100%"} className={open ? 'slide-in' : ''}>
        <Box sx={{
          background: "#ffffff",
          borderRadius: "11px",
          width:card_width ? card_width : 400
        }}>

        {!disableHead && <IconButton sx={{marginLeft:"auto",display:"block",padding:0}} aria-label="delete" onClick={() => handleClose()}>
          <img src={close} width={25} />
        </IconButton>}
        {content}
        </Box>
      </Box>
    </Modal>
  );
}
